import React from 'react';

/* Atoms */
import { Icon } from "js/components/atoms";
import checkIcon from "symbols/check.svg";

export default function ConversionFlowUsps({usps}) {
   return (
       <div className="row gutters-3 pt-6 pt-xl-12">
           {usps?.map((usp, index) => {
               return (
                   <div key={index} className="col-12 col-lg">
                       <div className="d-flex gap-3">
                           <Icon
                               url={checkIcon}
                               size={20}
                               theme='callout'
                           />

                           <div className="text--14 text--xl-16">
                               <p className="font-weight-bold mb-0 line-height-20">{usp.title}</p>
                               <p>{usp.subtitle}</p>
                           </div>
                       </div>
                   </div>
               )
           })}
       </div>
   )
}
